import PropTypes from 'prop-types';
import React, { useState } from 'react';
import IconButton from 'components/buttons/IconButton';
import Cross from 'components/svg/Cross';
import Link from 'next/link';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import styled from 'styled-components';
import media from 'styles/media';
import fonts from 'styles/fonts';

const AlertContainer = styled.div`
	display: flex;
	max-width: ${sizes.constrains.desktop + sizes.gutter.large * 2}px;
	margin: 0 auto;
	padding: 13px 0;

	${media.medium`
    align-items: flex-start;
  `}

	a {
		display: block;
		margin: 0 10px 0 70px;
		${media.medium`
      margin: 0 10px 0 32px;
    `}
		${media.small`
      margin: 0 10px 0 16px;
    `}
	}

	.closeAlert {
		transform: rotate(45deg);
		margin: 0 70px 0 auto;

		svg {
			width: 14px;
			height: 14px;

			path {
				fill: ${colors.primary.ocean};
			}
		}

		${media.medium`
      margin-right: 32px;
    `}

		${media.small`
      margin-right: 16px;
    `}
	}
`;
const Title = styled.h4`
	color: ${colors.primary.ocean};
	font-size: 14px;
	font-family: ${fonts.primary.bold};
	letter-spacing: 2px;
	line-height: 1.3;
	text-transform: uppercase;

	${media.medium`
  font-size: 12px;
  `}
`;

const Description = styled.p`
	color: ${colors.primary.ocean};
	font-size: 16px;
	line-height: 20px;

	${media.medium`
    font-size: 14px;
  `}
`;

/**
 * Alert component
 */

const Alert = ({ title, description, link }) => {
	const [showAlerts, setShowAlerts] = useState(true);

	if (!showAlerts) return null;

	return (
		<AlertContainer>
			<Link href={link} legacyBehavior>
				<a>
					<Title>{title}</Title>
					<Description>{description}</Description>
				</a>
			</Link>
			<IconButton className="closeAlert" onClick={() => setShowAlerts(false)} icon={<Cross color={colors.primary.ice} />} />
		</AlertContainer>
	);
};

Alert.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	link: PropTypes.string,
};

export default Alert;
